import { createSelector } from 'reselect';

export const getStoreKioskSettings = createSelector<
  AppState['storeKioskSettings'],
  AppState['storeKioskSettings']['settings'],
  FlipdishPrivate.StoreKioskSetting[]
>([(state) => state.settings], (settings) => {
  return settings;
});

export const getKioskLogo = createSelector<
  AppState,
  AppState['storeKioskSettings']['logoUrl'],
  AppState['currentApp']['LogoImageUrl'],
  { storeLogoUrl?: string; wlLogoUrl: string }
>(
  [(state) => state.storeKioskSettings.logoUrl, (state) => state.currentApp.LogoImageUrl],
  (storeLogoUrl, logoImageUrl) => {
    return { storeLogoUrl, wlLogoUrl: logoImageUrl! };
  }
);
